import axios from "axios";
import { authHeaderJson } from "../auth-header.service";

const getListMessageTopics = () => {
    return axios.get(`/api/SbMessageTopic/list`, { headers: authHeaderJson() } )
};

const getMessageTopicById = (messageTopicId) => {
    return axios.get(`/api/SbMessageTopic/${messageTopicId}`, { headers: authHeaderJson() } );
};

const addMessageTopic = (messageTopic) => {
    return axios.post(`/api/SbMessageTopic/add/`, messageTopic, { headers: authHeaderJson() } );
}

const addMessageTopicList = (messageTopics) => {
    return axios.post(`/api/SbMessageTopic/add/list`, messageTopics, { headers: authHeaderJson() } );
}

const saveMessageTopicById = (messageTopicId, objMessageTopic) => {
    return axios.put(`/api/SbMessageTopic/${messageTopicId}`, objMessageTopic, { headers: authHeaderJson() });
};

const deleteMessageTopic = (messageTopicId) => {
    return axios.delete(`/api/SbMessageTopic/${messageTopicId}`, { headers: authHeaderJson() });
}

export {
    getListMessageTopics,
    getMessageTopicById,
    addMessageTopic,
    addMessageTopicList,
    saveMessageTopicById,
    deleteMessageTopic
}
